import React from 'react'
import { Trans } from 'react-i18next'
import { useBoolean } from 'react-use'
import { v4 as uuid4 } from 'uuid'

import { DateTimeCustomOption, VariableResultDateTime, VariableSelectFeatureFlag } from '@makyoapp/makyo-common'
import { Date16, Datetime16 } from '@makyoapp/makyo-icon/icon'

import { VariableWrapper } from './VariableWrapper'

export function getDateTimeIcon(value: DateTimeCustomOption) {
  switch (value) {
    case DateTimeCustomOption.Now:
    case DateTimeCustomOption.Today:
    case DateTimeCustomOption.Tomorrow:
    case DateTimeCustomOption.Yesterday:
    case DateTimeCustomOption.CurrentMonth:
    case DateTimeCustomOption.LastMonth:
    case DateTimeCustomOption.NextMonth:
    case DateTimeCustomOption.CurrentYear:
    case DateTimeCustomOption.LastYear:
    case DateTimeCustomOption.NextYear:
      return <Date16 />
  }
}

export function getDateTimeLabel(value: DateTimeCustomOption) {
  switch (value) {
    case DateTimeCustomOption.Now:
      return 'Now'
    case DateTimeCustomOption.Today:
      return 'Today'
    case DateTimeCustomOption.Tomorrow:
      return 'Tomorrow'
    case DateTimeCustomOption.Yesterday:
      return 'Yesterday'
    case DateTimeCustomOption.CurrentMonth:
      return 'Current Month'
    case DateTimeCustomOption.LastMonth:
      return 'Last Month'
    case DateTimeCustomOption.NextMonth:
      return 'Next Month'
    case DateTimeCustomOption.CurrentYear:
      return 'Current Year'
    case DateTimeCustomOption.LastYear:
      return 'Last Year'
    case DateTimeCustomOption.NextYear:
      return 'Next Year'
  }
}
export default function VariableDateTime({
  id,
  onChange,
}: {
  id?: string
  onChange?: (newValue: VariableResultDateTime) => void
}) {
  const [show, setShow] = useBoolean(false)
  return (
    <VariableWrapper
      id={id}
      show={show}
      setShow={setShow}
      title={<Trans>Date & Time</Trans>}
      icon={<Datetime16 width={16} height={16} />}
      defaultHeight={false}
      menuClassName='z-[302]'
    >
      {Object.entries(DateTimeCustomOption).map(([, v]) => {
        return (
          <button
            key={v}
            onClick={() => {
              const val: VariableResultDateTime = {
                id: uuid4(),
                flag: VariableSelectFeatureFlag.DateTime,
                variant: v as DateTimeCustomOption,
              }
              onChange?.(val)
            }}
            className='gap-2 sdd-item'
          >
            {getDateTimeIcon(v as DateTimeCustomOption)}
            <span>
              <Trans>{getDateTimeLabel(v as DateTimeCustomOption)}</Trans>
            </span>
          </button>
        )
      })}
    </VariableWrapper>
  )
}
